
import { Injectable } from '@angular/core';

@Injectable()

export class Global {
	
	public content:string;
	public showCaroModal:boolean = false;
	public mobile:boolean = false;
	public setupPinType:string = 'newSetup'
	public cardBlockScreen:number = 1;
	public successScreenRef = {}
	constructor(
	) {}


}